/**
 * Step 3: Email
 * Coleta o endereço de email do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validateEmail } from '../validators';
import { httpInterceptor } from '@/services/http.interceptor';

const Step3_Email: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ email: data.email || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [checking, setChecking] = useState(false);

  const handleChange = (value: string) => {
    setLocalData({ email: value });
    setErrors({});
  };

  const handleNext = async () => {
    const validation = validateEmail(localData.email);
    
    if (!validation.valid) {
      setErrors({ email: validation.error || 'Email inválido' });
      return;
    }

    // Checar existência do email nos pré-cadastros
    setChecking(true);
    try {
      const response = await httpInterceptor.get(`/user/has-pre-register-email/${encodeURIComponent(localData.email.trim())}`);
      const result = await response.json();

      if (result?.data?.id) {
        setErrors({ email: 'Já existe um pré-cadastro com este email.' });
        setChecking(false);
        return;
      }
    } catch (error) {
      console.error('Erro ao verificar email:', error);
    } finally {
      setChecking(false);
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu email?"
      description="Usaremos esse email para contato"
    >
      <FormFieldGroup
        label="Email"
        error={errors.email}
        required
      >
        <input
          type="email"
          placeholder="seu.email@exemplo.com"
          value={localData.email}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading || checking}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step3_Email;
